import React, { useState } from "react";
import { Layout, theme } from "antd";
import "./layout.scss";
import SideMenu from "./components/Sidemenu";
import TopHeader from "./components/Header";
import { Footer } from "antd/es/layout/layout";

const { Content } = Layout;

const PageLayout = ({ children }: any) => {
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <div className="d-flex" style={{ height: "100vh", overflow: "hidden" }}>
      <SideMenu collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout style={{ height: "100vh", overflow: "hidden" }}>
        <TopHeader collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content className="pagelayout_container shop-shell">
          {children}
        </Content>
      </Layout>
    </div>
  );
};

export default PageLayout;
